import classificationsShader from "./viewer/textures/colormaps/classifications.png";

export interface Classification {
  id: number;
  name: string;
}

const numberOfDefinedClassifications = 19;
export const numberOfClassifications = 256;

export const classifications = [
  {
    id: 0,
    name: "Never Classified"
  },
  {
    id: 1,
    name: "Unassigned"
  },
  {
    id: 2,
    name: "Ground"
  },
  {
    id: 3,
    name: "Low Vegetation"
  },
  {
    id: 4,
    name: "Medium Vegetation"
  },
  {
    id: 5,
    name: "High Vegetation"
  },
  {
    id: 6,
    name: "Building"
  },
  {
    id: 7,
    name: "Noise"
  },
  {
    id: 8,
    name: 'Model Key/Reserved'
  },
  {
    id: 9,
    name: "Water"
  },
  {
    id: 10,
    name: "Rail"
  },
  {
    id: 11,
    name: "Road Surface"
  },
  {
    id: 12,
    name: 'Overlap/Reserved'
  },
  {
    id: 13,
    name: "Wire - Guard"
  },
  {
    id: 14,
    name: "Wire - Conductor"
  },
  {
    id: 15,
    name: "Transmission Tower"
  },
  {
    id: 16,
    name: "Wire - Connector"
  },
  {
    id: 17,
    name: "Bridge Deck"
  },
  {
    id: 18,
    name: "High Noise"
  },
  ...Array.from(Array(numberOfClassifications - numberOfDefinedClassifications).keys()).map(key => ({id: key + numberOfDefinedClassifications, name: 'Reserved'}))
];

export const getClassificationColors = (): Promise<string[]> => {
  return new Promise(resolve => {
    const image = new Image();

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;

      const context = canvas.getContext('2d');
      context.drawImage(image, 0, 0);

      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      let colors = [];

      for (let i = 0; i < classifications.length; i++) {
        let index = i * 4;

        let red = imageData.data[index] << 16;
        let green = imageData.data[index + 1] << 8;
        let blue = imageData.data[index + 2];

        const hexColor = `#${(red + blue + green).toString(16).padStart(6, '0')}`;
        colors.push(hexColor);
      }

      resolve(colors);
    };

    image.src = classificationsShader;
  });
};